import { format } from "date-fns";
import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Parcel } from "@/features/modules/parcel/objects/Parcel";
import { parcelModel } from "../ParcelModel";

export const getParcelsWithFilters = async (companyId: string, date: Date, state: string): Promise<Parcel[]> => {
  try {
    const snapshotQuery: Query<Parcel> = query(
      parcelModel.getPathReference().withConverter(parcelModel.firestoreConverter),
      where("inboundShipment.company.id", "==", companyId),
      where("state", "==", state),
      where("lifeEndSort", ">=", format(date, "yyyy-MM-dd"))
    );

    const snapshot: QuerySnapshot<Parcel> = await getDocs(parcelModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return [];

    return snapshot.docs.map((doc) => doc.data()).filter((parcel: Parcel) => parcel.lifeStartSort <= format(date, "yyyy-MM-dd"));
  } catch (error: unknown) {
    appFaultModel.catchAppError("ParcelModel.getParcelsWithFilters", { companyId, date, state }, error);
    return [];
  }
};
